if (!customElements.get('cart-tier-discount')) {
  class CartTierDiscount extends HTMLElement {
    connectedCallback() {
      this.checkTime = this.updateVisibility.bind(this);
      document.addEventListener('visibilitychange', this.checkTime);
      document.addEventListener('on:cart-drawer:before-open', this.checkTime);
      this.updateVisibility();
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.checkTime);
      document.removeEventListener('on:cart-drawer:before-open', this.checkTime);
    }

    updateVisibility() {
      clearTimeout(this.timer);
      const now = Date.now();
      const start = Number(this.dataset.start);
      const end = Number(this.dataset.end);
      // Only Liquid's request.design_mode gate can emit this preview flag.
      const preview = this.dataset.preview === 'true';
      const valid = Number.isFinite(start) && Number.isFinite(end) && start < end;
      this.hidden = !valid || !(preview || (now >= start && now < end));

      if (valid && !preview && now < end) {
        const nextCheck = now < start ? start : end;
        this.timer = setTimeout(this.checkTime, Math.min(nextCheck - now, 60000));
      }
    }
  }

  customElements.define('cart-tier-discount', CartTierDiscount);
}
